module.exports = __webpack_public_path__ + "officialStatic/img/logo22.083afd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo22.png
// module id = wcq+
// module chunks = 0